import { AddPlayer } from "monkeybattle-shared";

const defaultCards = [
  // neutral
  {
    name: "Camo Ban",
  },
  {
    name: "Impatient Chimp",
  },
  {
    name: "Coco Blocker",
  },
  {
    name: "Boomer Investor",
  },
  {
    name: "Moderate Tipper",
  },
  {
    name: "Peel Head Monkey",
  },
  {
    name: "Hippie Investor",
  },
  {
    name: "Healthy Milkshake",
  },
  {
    name: "Pointy Banana",
  },
  {
    name: "Decent Tipper",
  },
  {
    name: "Jungle Wood Wall",
  },
  {
    name: "BRPD Bolici",
  },
  {
    name: "monKeyprinter BRRrain",
  },
  {
    name: "Serenifty",
  },
  {
    name: "Welcome to the monKeyverse",
  },
  {
    name: "Shitcoin CEO",
  },
  // memes
  {
    name: "Banonus",
  },
  {
    name: "spooKey Badge 2021",
  },
  {
    name: "EA",
  },
  {
    name: "Ketamine",
  },
];

export const defaultAiUser: AddPlayer = {
  user: {
    id: 0,
    waxAddress: "AI Opponent",
    level: 0,
    xp: 0,
  },
  deck: {
    monkey: {
      id: 42421,
      name: "The Bounty Hunter",
      rarity: 0,
      monkeyClass: "Memes",
      img: "QmPGBCWHaVp8ZP8WENxBoq6AqUSeseqsziZXy8gDVMpV86",
      backimg: "QmV98NfVgiCgRV1Q8F895zaUyw23bCqUCd9xGhb1GseMxm",
      gameClassId: 1,
    },
    cards: defaultCards,
  },
};

export const staticPlayerUser: AddPlayer = {
  user: {
    id: 1,
    waxAddress: "Demo User",
    level: 0,
    xp: 0,
  },
  deck: {
    monkey: {
      id: 42421,
      name: "The Bounty Hunter",
      rarity: 0,
      monkeyClass: "Memes",
      img: "QmPGBCWHaVp8ZP8WENxBoq6AqUSeseqsziZXy8gDVMpV86",
      backimg: "QmV98NfVgiCgRV1Q8F895zaUyw23bCqUCd9xGhb1GseMxm",
      gameClassId: 1,
    },
    cards: defaultCards,
  },
};
